import React from 'react'
import AuthLayout from '../authlayout/authlayout'
import styles from './signupstudent.module.scss'
import { ERCText } from 'components/text'
import ERCInput from 'components/Input'
import { MdOutlineErrorOutline } from "react-icons/md";
import { ERCForm } from 'components/form'
import { toast } from 'react-toastify'
import * as Yup from 'yup';
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { setUser } from 'store/reducers/user'
import dropDown from './drodown'
import { ERCButton } from 'components/button'

const SignupGuest = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    const {Occupation, State} = dropDown
    

    const schema = Yup.object().shape({
        email: Yup.string().required(),
        password: Yup
            .string()
            .required("Password is Required")
            .matches(
                /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
                "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
            ),
        confirm: Yup
            .string()
            .oneOf([Yup.ref("password"), null], "Passwords must match")
            .required("Confirm Password is Required")
            .matches(
                /^(?=.*[A-Za-z])(?=.*[0-9])(?=.*[!@#$%^&*])[A-Za-z0-9!@#$%^&*]{8,}$/,
                "Password must be at least 8 characters and must contain at least an alphabet, a number, and a special character (!@#$%^&*)"
            ),
        fullName: Yup.string().required(),
        occupation: Yup.string().required(),
        state: Yup.string().required(),

    })

    const handleSuccess = (res) => {
        dispatch(setUser(res));
        navigate(-1);
      };

    return (
        <AuthLayout >
            <div className={styles.body}>

                <div className={styles.signup}>
                <div className={styles.signin}>
                <ERCButton bgcolor='#F6F5B2' color='#00296B' width='100px' onClick={() => navigate(-1)}> Sign In</ERCButton>
             </div>
                    <div className={styles.logo}>
                        <img src={"https://res.cloudinary.com/dmrtylvtc/image/upload/v1716814039/ERC/erc_main_logo_nbljik.svg"} alt="logo" />
                    </div>

                    <div className={styles.create}>
                        <ERCText weight='700' size='30px'>Create An Account</ERCText>
                        <div className={styles.several}>
                            <span style={{ color: '#FFD600' }} ><MdOutlineErrorOutline size={20} /> </span>
                            <ERCText size='12px'>Access all our courses today as a <span style={{ color: '#FFD600', fontWeight: '600' }}>Guest.</span> Kindly fill out the form.</ERCText>
                        </div>
                    </div>
                    <ERCForm
                     extraFields={{userType:"guest"}}
                        validationSchema={schema}
                        inputsContainer={'!w-[100%] justify-center items-center flex flex-col gap-[24px]'}
                        className={'!w-[auto] flex flex-col gap-[56px] '}
                        btnClass={'!w-[100%] !bg-[#FFD600] !text-[16px] !text-[#00296B]'}
                        btnText={'Create Account'}
                        method={'post'}
                        url={'/user/register'}
                        noToken
                        // onSuccess={(res) => {
                        //     dispatch(setUser(res))
                        //     navigate('/students-dashboard')
                        // }}
                        handleSuccess={handleSuccess}
                        onError={err => {
                            if (err?.response) {
                                toast.error('User already exists')
                            }
                        }}

                    >

                        <div style={{ display: 'flex', gap: '20px', }}>
                            <div >
                                <ERCInput containerClass='w-[auto]' label='Full Name' name='fullName' placeholder='Enter your full name' />
                            </div>
                            <div >
                                <ERCInput containerClass='w-[auto]' label='Email Address' name='email' placeholder='Enter your email address' />
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px' }}>
                            <div >
                                <ERCInput containerClass='!w-[255px]'  type="select" label='Occupation' options={Occupation} name='occupation' placeholder='Select occupation'  />
                            </div>
                            <div >
                                <ERCInput  type="select" containerClass='!w-[255px]' label='State' options={State} placeholder='Select location' name="state" />
                            </div>
                        </div>
                        <div style={{ display: 'flex', gap: '20px' }}>
                            <div >
                                <ERCInput containerClass='w-[auto]' type="password" label='Password' name='password' placeholder='Enter Password' />
                            </div>
                            <div >
                                <ERCInput containerClass='w-[auto]' type="password" label='Confirm Password' name='confirm' placeholder='Confirm Password' />
                            </div>
                        </div>

                    </ERCForm>

                    <div>
                        <ERCText size='15px'>By creating an Account you agree to the <span style={{ color: '#FFD600' }}>Terms & Conditions</span> and <span style={{ color: '#FFD600' }}>Privacy Policy </span></ERCText>
                    </div>
                </div>
            </div>

        </AuthLayout>
    )
}


export default SignupGuest